const routes = {
  root: '/marlins-english-test/details',
}

export default routes
